import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';

import { FooterComponent } from './component/footer/footer.component';
import { BaseV1Component } from './component/v1/base/base-v1.component';
import { DataV1Component } from './component/v1/data/data-v1.component';
import { TextV1Component } from './component/v1/text/text-v1.component';
import { BaseV2Component } from './component/v2/base/base-v2.component';
import { TextV2Component } from './component/v2/text/text-v2.component';
import { EventCentreCPopDialogComponent } from './event-centre-c-pop-dialog.component';
import { TranslationIdMap } from './event-centre-c-pop-dialog.i18n';

@NgModule({
    declarations: [
        BaseV1Component,
        BaseV2Component,
        DataV1Component,
        EventCentreCPopDialogComponent,
        FooterComponent,
        TextV1Component,
        TextV2Component,
    ],
    imports: [
        CmpsButtonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
})
export class CmpsEventCentreCPopDialogModule {}
